export const MARKET_START_DAYS = {
  'de-DE': 1,
  'en-AU': 0,
  'en-CA': 0,
  'en-GB': 1,
  'en-IN': 0,
  'en-NZ': 1,
  'en-US': 0,
  'es-ES': 1,
  'es-MX': 0,
  'fr-CA': 0,
  'fr-FR': 1,
  'it-IT': 1,
  'ja-JP': 0,
  'nl-NL': 1,
  'sv-SE': 1,
  'en-HK': 0,
  'en-SG': 1,
  'zh-HK': 0,
};

export default MARKET_START_DAYS;
